import { render, staticRenderFns } from "./colaboradores.fopag.item.vue?vue&type=template&id=0b7d7884&"
import script from "./colaboradores.fopag.item.vue?vue&type=script&lang=js&"
export * from "./colaboradores.fopag.item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports